import React, { useState, useEffect, useRef } from "react";
import { Button } from "ui/components/button";
import { Badge } from "ui/components/badge";
import { X, Plus, Users } from "lucide-react";
import EmployeeInput from "./input";
import { RenderProfile } from "components/render-profile";

const EmployeeMultiSelectSheet = ({
  value = [],
  onChange,
  placeholder = "Select Employees",
  className = "",
  disabled = false,
  filter = {},
  excludedEmployeeIds = [],
  info = ""
}) => {
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const employeeInputRef = useRef(null);

  useEffect(() => {
    setSelectedEmployees(Array.isArray(value) ? value : []);
  }, [value]);

  const handleEmployeeSelect = (employees) => {
    setSelectedEmployees(employees);
    onChange?.(employees);
  };

  const handleConfirm = () => {
    onChange?.(selectedEmployees);
  };

  const handleRemoveEmployee = (employeeId) => {
    const newSelection = selectedEmployees.filter(emp => emp.id !== employeeId);
    setSelectedEmployees(newSelection);
    onChange?.(newSelection);
  };



  const filters = {
    user: { status: { _eq: 'active' } },
    ...filter,
  };

  return (
    <div className={`space-y-2 ${className}`}>
      {/* Employee Input Sheet */}
      <EmployeeInput
        onChange={handleEmployeeSelect}
        value={selectedEmployees}
        multiselect={true}
        singleSelect={false}
        allowRemoval={true}
        set="all"
        excludedEmployeeIds={[
          ...excludedEmployeeIds,
          ...selectedEmployees.map((emp) => emp.id),
        ]}
        filters={filters}
        info={info}
      >
        {/* Custom trigger that looks like an input field */}
        <div
          className={`flex flex-wrap gap-2 min-h-[40px] p-2 border rounded-md bg-background cursor-pointer hover:bg-accent/50 ${disabled ? 'cursor-not-allowed opacity-50' : ''
            }`}
        >
          {selectedEmployees.length === 0 ? (
            <div className="text-muted-foreground flex items-center gap-2">
              <Users className="h-4 w-4" />
              {placeholder}
            </div>
          ) : (
            <>
              {selectedEmployees.map((employee) => (
                <Badge
                  key={employee.id}
                  variant="secondary"
                  className="px-2 py-1 flex items-center gap-1 pr-1"
                >
                  <RenderProfile user={employee} className="size-4" />
                  {!disabled && (
                    <Button
                      type="button"
                      variant="ghost"
                      size="sm"
                      className="h-4 w-4 p-0"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleRemoveEmployee(employee.id);
                      }}
                    >
                      <X className="h-3 w-3" />
                    </Button>
                  )}
                </Badge>
              ))}
            </>
          )}
        </div>
      </EmployeeInput>
    </div>
  );
};

export default EmployeeMultiSelectSheet;
